import axios from "axios";

// export const imageurl = "https://shrijasilver.com/ShrijaAPI/";
// export const baseurl = 'https://shrijasilver.com/ShrijaAPI/api/';
// export const projectNo = 'Shrija';
// export const projectName = 'Shrija Silver';

// export const imageurl = "https://www.indianfilms.in/lifecodeAPI/";
// export const baseurl = 'https://www.indianfilms.in/lifecodeAPI/api/';
// export const projectNo = 'Lifecode';
// export const projectName = 'Lifecode';

export const imageurl = "https://www.indianfilms.in/lifecodetestapi/";
export const baseurl = 'https://www.indianfilms.in/lifecodetestapi/api/';
export const projectNo = 'Lifecode';
export const projectName = 'Lifecode';

// export const imageurl = "https://www.indianfilms.in/MUjesmsAPI/";
// export const baseurl = 'https://www.indianfilms.in/MUjesmsAPI/api/';
// export const projectNo = 'MUJems';
// export const projectName = 'MUJems';

// export const imageurl = "https://api.gailee.in/";
// export const baseurl = 'https://api.gailee.in/api/';
// export const projectNo = `GAILEE`;
// export const projectName = 'Gailee';

// export const imageurl = "https://www.indianfilms.in/GallyAPI/";
// export const baseurl = 'https://www.indianfilms.in/GallyAPI/api/';
// export const projectNo = `GAILEE`;
// export const projectName = 'Gailee';

// export const imageurl = "https://www.indianfilms.in/ShrisetuAPI/";
// export const baseurl = 'https://www.indianfilms.in/ShrisetuAPI/api/';
// export const projectNo = `Shrisetu`;
// export const projectName = 'Shrisetu';

export const API_URL = {
    SentOtp: 'SentOtp/SentOtp',
    VerifyOTP: 'SentOtp/VerifyOTP',

    login: 'MemberLogin/login',
    GetLoginDetailAll: 'LoginDetail/GetLoginDetailAll',
    DeleteLoginDetailById: 'LoginDetail/DeleteLoginDetailById',
    GetLoginDetailById: 'LoginDetail/GetLoginDetailById',
    GetMemberLoginById: 'MemberLogin/GetMemberLoginById',

    SaveProductCategory: 'ProductCategory/SaveProductCategory',
    GetProductCategory: 'ProductCategory/GetProductCategory',
    GetProductCategoryAll: 'ProductCategory/GetProductCategoryAll',
    DeleteProductCategoryById: 'ProductCategory/DeleteProductCategoryById',
    IsDisplayProductCategoryById: 'ProductCategory/IsDisplayProductCategoryById',
    ActiveProductCategoryById: 'ProductCategory/ActiveProductCategoryById',
    UploadProductCategoryImage: 'ProductCategory/UploadProductCategoryImage',

    SaveProductSubCategory: 'ProductSubCategory/SaveProductSubCategory',
    GetProductSubCategory: 'ProductSubCategory/GetProductSubCategory',
    GetProductSubCategoryAll: 'ProductSubCategory/GetProductSubCategoryAll',
    DeleteProductSubCategoryById: 'ProductSubCategory/DeleteProductSubCategoryById',
    IsDisplayProductSubCategoryById: 'ProductSubCategory/IsDisplayProductSubCategoryById',
    ActiveProductSubCategoryById: 'ProductSubCategory/ActiveProductSubCategoryById',
    UploadProductSubCategoryImage: 'ProductSubCategory/UploadProductSubCategoryImage',
    GetProductSubCategoryByCategoryId: 'ProductSubCategory/GetProductSubCategoryByCategoryId',
    GetProductSubCategoryByMultiCategoryId: 'ProductSubCategory/GetProductSubCategoryByMultiCategoryId',

    SaveProductDetail: 'ProductDetail/SaveProductDetail',
    GetProductDetailAll: 'ProductDetail/GetProductDetailAll',
    GetProductDetail: 'ProductDetail/GetProductDetail',
    DeleteProductDetailById: 'ProductDetail/DeleteProductDetailById',
    ActiveProductDetailById: 'ProductDetail/ActiveProductDetailById',
    IsDisplayProductDetailById: 'ProductDetail/IsDisplayProductDetailById',
    GetProductDetailById: 'ProductDetail/GetProductDetailById',
    IsFavProductDetailById: 'ProductDetail/IsFavProductDetailById',
    IsCustomProductDetailById: 'ProductDetail/IsCustomProductDetailById',
    IsHomeProductDetailById: 'ProductDetail/IsHomeProductDetailById',
    IsOccasionProductDetailById: 'ProductDetail/IsOccasionProductDetailById',

    saveSpecification: 'Specification/SaveSpecification',
    getSpecification: 'Specification/GetSpecification',
    deleteSpecification: 'Specification/DeleteSpecificationById',
    isActiveSpecification: 'Specification/ActiveSpecificationById',

    SaveProductSpecification: 'ProductSpecification/SaveProductSpecification',
    GetProductSpecificationAll: 'ProductSpecification/GetProductSpecificationAll',
    DeleteProductSpecificationById: 'ProductSpecification/DeleteProductSpecificationById',
    IsDisplayProductSpecificationById: 'ProductSpecification/IsDisplayProductSpecificationById',
    ActiveProductSpecificationById: 'ProductSpecification/ActiveProductSpecificationById',

    SaveProductImage: 'ProductImage/SaveProductImage',
    GetProductImageAll: 'ProductImage/GetProductImageAll',
    DeleteProductImageById: 'ProductImage/DeleteProductImageById',
    IsDisplayProductImageById: 'ProductImage/IsDisplayProductImageById',
    ActiveProductImageById: 'ProductImage/ActiveProductImageById',
    IsHeaderProductImageById: 'ProductImage/IsHeaderProductImageById',
    GetProductImageByProductId: 'ProductImage/GetProductImageByProductId',
    GetProductSpecificationByProductId: 'ProductSpecification/GetProductSpecificationByProductId',

    GetTaxType: 'TaxType/GetTaxType',

    GetCouponAll: 'Coupon/GetCouponAll',
    GetCoupon: 'Coupon/GetCoupon',
    SaveCoupon: 'Coupon/SaveCoupon',
    ActiveCouponById: 'Coupon/ActiveCouponById',
    DeleteCouponById: 'Coupon/DeleteCouponById',

    SaveBlogDetail: 'BlogDetail/SaveBlogDetail',
    GetBlogDetailAll: 'BlogDetail/GetBlogDetailAll',
    GetBlogDetail: 'BlogDetail/GetBlogDetail',
    DeleteBlogDetailById: 'BlogDetail/DeleteBlogDetailById',

    GetMenuDetailByTypeId: "RolePermission/GetMenuDetailByTypeId",

    GetEnquiryAll: 'Enquiry/GetEnquiryAll',
    DeleteEnquiryById: 'Enquiry/DeleteEnquiryById',

    GetFaqDetailAll: 'FaqDetail/GetFaqDetailAll',
    SaveFaqDetail: 'FaqDetail/SaveFaqDetail',
    DeleteFaqDetailById: 'FaqDetail/DeleteFaqDetailById',

    GetProductOrderDetail: 'ProductOrder/GetProductOrderDetail',
    GetProductOrderByLoginId: 'ProductOrder/GetProductOrderByLoginId',
    UpdatePaymentResponse: 'ProductOrder/UpdatePaymentResponse',
    CreateShipment: 'ShipmentOrder/CreateShipment',
    GetProductOrderByOrderId: 'ProductOrder/GetProductOrderByOrderId',

    SaveCancelType: 'CancelType/SaveCancelType',
    GetCancelTypeAll: 'CancelType/GetCancelTypeAll',
    GetCancelType: 'CancelType/GetCancelType',
    ActiveCancelTypeById: 'CancelType/ActiveCancelTypeById',
    DeleteCancelTypeById: 'CancelType/DeleteCancelTypeById',
    IsRefundCancelTypeById: 'CancelType/IsRefundCancelTypeById',
    CancelShipment: 'ProductCancel/CancelShipment',
    UpdateProductRefund: 'ProductCancel/UpdateProductRefund',

    SaveRetrunType: 'RetrunType/SaveRetrunType',
    GetRetrunTypeAll: 'RetrunType/GetRetrunTypeAll',
    GetRetrunType: 'RetrunType/GetRetrunType',
    ActiveRetrunTypeById: 'RetrunType/ActiveRetrunTypeById',
    DeleteRetrunTypeById: 'RetrunType/DeleteRetrunTypeById',

    GetProductCancel: 'ProductCancel/GetProductCancel',
    DeleteProductCancelById: 'ProductCancel/DeleteProductCancelById',
    ActiveProductCancelById: 'ProductCancel/ActiveProductCancelById',
    UpdateProductCancel: 'ProductCancel/UpdateProductCancel',

    SaveProductOffer: 'ProductOffer/SaveProductOffer',
    GetProductOffer: 'ProductOffer/GetProductOffer',
    ActiveProductOfferById: 'ProductOffer/ActiveProductOfferById',
    GetProductOfferAll: 'ProductOffer/GetProductOfferAll',
    DeleteProductOfferById: 'ProductOffer/DeleteProductOfferById',

    GetProductOrderSummary: 'ProductOrder/GetProductOrderSummary',
    GetProductOrderDetailMonthly: 'ProductOrder/GetProductOrderDetailMonthly',

    GetDashboardSummary: 'ProductOrder/GetDashboardSummary',
    IsStockProductDetailById: 'ProductDetail/IsStockProductDetailById',

    GetProductRatingAll: 'ProductRating/GetProductRatingAll',
    DeleteProductRatingById: 'ProductRating/DeleteProductRatingById',
    SaveProductRating: 'ProductRating/SaveProductRating',

    GetColorTypeAll: 'ColorType/GetColorTypeAll',
    SaveColorType: 'ColorType/SaveColorType',
    ActiveColorTypeById: 'ColorType/ActiveColorTypeById',
    DeleteColorTypeById: 'ColorType/DeleteColorTypeById',
    GetColorType: 'ColorType/GetColorType',

    SaveSizeType: 'SizeType/SaveSizeType',
    GetSizeType: 'SizeType/GetSizeType',
    GetSizeTypeAll: 'SizeType/GetSizeTypeAll',
    ActiveSizeTypeById: 'SizeType/ActiveSizeTypeById',
    DeleteSizeTypeById: 'SizeType/DeleteSizeTypeById',

    SaveStockDetail: 'StockDetail/SaveStockDetail',
    GetStockDetailAll: 'StockDetail/GetStockDetailAll',
    GetStockDetail: 'StockDetail/GetStockDetail',
    DeleteStockDetailById: 'StockDetail/DeleteStockDetailById',
    ActiveStockDetailById: 'StockDetail/ActiveStockDetailById',

    SaveBannerType: 'BannerType/SaveBannerType',
    GetBannerType: 'BannerType/GetBannerType',
    DeleteBannerTypeById: 'BannerType/DeleteBannerTypeById',
    ActiveBannerTypeById: 'BannerType/ActiveBannerTypeById',

    SaveBanner: 'Banner/SaveBanner',
    GetBanner: 'Banner/GetBanner',
    GetBannerByBannerType: 'Banner/GetBannerByBannerType',
    DeleteBannerById: 'Banner/DeleteBannerById',
    ActiveBannerById: 'Banner/ActiveBannerById',

    GetTemplateByProductCategoryId: 'Specification/GetTemplateByProductCategoryId',
    ImportTemplate: 'BulkData/ImportTemplate',
    UploadProductImages: 'BulkData/UploadProductImages',
    GetImage: 'BulkData/GetImage',

    SaveProductSku: 'ProductSku/SaveProductSku',
    GetProductSkuAll: 'ProductSku/GetProductSkuAll',
    GetProductSkuByProductColorId: 'ProductSku/GetProductSkuByProductColorId',
    GetProductSkuById: 'ProductSku/GetProductSkuById',
    DeleteProductSkuById: 'ProductSku/DeleteProductSkuById',
    ActiveProductSkuById: 'ProductSku/ActiveProductSkuById',
    GetProductSkuByProductId: 'ProductSku/GetProductSkuByProductId',
    UploadImages: 'ProductImage/UploadImages',

    GetStoctSummary: 'StockDetail/GetStoctSummary',

    GetCustomOrderAll: 'CustomOrder/GetCustomOrderAll',
    GetCustomOrder: 'CustomOrder/GetCustomOrder',
    DeleteCustomOrderById: 'CustomOrder/DeleteCustomOrderById',
    ActiveCustomOrderById: 'CustomOrder/ActiveCustomOrderById',
    GetSpecificationByProductCategoryId: 'Specification/GetSpecificationByProductCategoryId',
    IsHeaderProductImageByProductImageId: 'ProductImage/IsHeaderProductImageByProductImageId',

    GetWeightTypeAll: 'WeightType/GetWeightTypeAll',
    SaveWeightType: 'WeightType/SaveWeightType',
    GetWeightType: 'WeightType/GetWeightType',
    DeleteWeightTypeById: 'WeightType/DeleteWeightTypeById',
    ActiveWeightTypeById: 'WeightType/ActiveWeightTypeById',

    SaveShapeType: 'ShapeType/SaveShapeType',
    GetShapeType: 'ShapeType/GetShapeType',
    DeleteShapeTypeById: 'ShapeType/DeleteShapeTypeById',
    ActiveShapeTypeById: 'ShapeType/ActiveShapeTypeById',

    SaveStaticPageDescription: 'StaticPageDescription/SaveStaticPageDescription',
    GetStaticPageDescription: 'StaticPageDescription/GetStaticPageDescription',
    DeleteStaticPageDescriptionById: 'StaticPageDescription/DeleteStaticPageDescriptionById',
    GetStaticPageDescriptionById:'StaticPageDescription/GetStaticPageDescriptionById',

    GetStaticPage: 'StaticPage/GetStaticPage',
    SaveStaticPage: 'StaticPage/SaveStaticPage',
    DeleteStaticPageById: 'StaticPage/DeleteStaticPageById',

    IsExchangeProductOrderById: 'ProductOrder/IsExchangeProductOrderById',

    SaveSocialVideo: 'SocialVideo/SaveSocialVideo',
    GetSocialVideo: 'SocialVideo/GetSocialVideo',
    GetSocialVideoAll: 'SocialVideo/GetSocialVideoAll',
    ActiveSocialVideoById: 'SocialVideo/ActiveSocialVideoById',
    DeleteSocialVideoById: 'SocialVideo/DeleteSocialVideoById',
  
    SaveInstaFeed: 'InstaFeed/SaveInstaFeed',
    GetInstaFeed: 'InstaFeed/GetInstaFeed',
    GetInstaFeedAll: 'InstaFeed/GetInstaFeedAll',
    ActiveInstaFeedById: 'InstaFeed/ActiveInstaFeedById',
    DeleteInstaFeedById: 'InstaFeed/DeleteInstaFeedById',
  
    SaveCelebSection: 'CelebSection/SaveCelebSection',
    GetCelebSection: 'CelebSection/GetCelebSection',
    GetCelebSectionAll: 'CelebSection/GetCelebSectionAll',
    ActiveCelebSectionById: 'CelebSection/ActiveCelebSectionById',
    DeleteCelebSectionById: 'CelebSection/DeleteCelebSectionById',

    GetCustomEnquiry: 'CustomEnquiry/GetCustomEnquiry',
    DeleteCustomEnquiryById: 'CustomEnquiry/DeleteCustomEnquiryById'
}

const axiosIns = axios.create({
    baseURL: baseurl,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default axiosIns;